import { render, staticRenderFns } from "./BackendJobs.vue?vue&type=template&id=72afd8bd&scoped=true&"
import script from "./BackendJobs.vue?vue&type=script&lang=ts&"
export * from "./BackendJobs.vue?vue&type=script&lang=ts&"
import style0 from "./BackendJobs.vue?vue&type=style&index=0&id=72afd8bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afd8bd",
  null
  
)

export default component.exports